/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { archiveTrackModelSchema } from "../archiveTrackModelSchema.ts";
import { badResponseModelSchema } from "../badResponseModelSchema.ts";
import { guidCreatedOrUpdatedEntityModelSchema } from "../guidCreatedOrUpdatedEntityModelSchema.ts";
import { z } from "zod";

export const patchApiTracksIdStatusPathParamsSchema = z.object({
    "Id": z.string().uuid().describe("Идентификатор архивироваемого трека")
    })

/**
 * @description Идентификатор архивированного трека
 */
export const patchApiTracksIdStatus200Schema = z.lazy(() => guidCreatedOrUpdatedEntityModelSchema)

/**
 * @description Ошибка валидации
 */
export const patchApiTracksIdStatus400Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Пользователь не авторизован
 */
export const patchApiTracksIdStatus401Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Недостаточно прав для выполнения запроса
 */
export const patchApiTracksIdStatus403Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Трек не найден
 */
export const patchApiTracksIdStatus404Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Внутренняя ошибка сервера
 */
export const patchApiTracksIdStatus500Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Тело запроса
 */
export const patchApiTracksIdStatusMutationRequestSchema = z.lazy(() => archiveTrackModelSchema).describe("Тело запроса")

export const patchApiTracksIdStatusMutationResponseSchema = z.lazy(() => patchApiTracksIdStatus200Schema)